<template>
  <el-collapse class="cart" v-model="activeSections">
    <el-collapse-item v-if="user" name="customer">
      <template slot="title">
        <router-link v-if="editable" :to="{name: 'your-details', params: {redirect: $route.name}}"><el-button size="mini" icon="el-icon-edit" circle plain></el-button></router-link>
        Your Details
      </template>
      <table>
        <tbody>
          <tr><th>Name</th><td>{{customerName}}</td></tr>
          <tr v-if="!user.is_guest"><th>Email</th><td>{{user.email}}</td></tr>
          <tr><th>Phone</th><td>{{user.phone_number}}</td></tr>
          <tr><th>Address</th><td>{{customerAddress}}</td></tr>
        </tbody>
      </table>
    </el-collapse-item>
    <el-collapse-item name="booking" v-if="order.scenario">
      <template slot="title">
        <router-link v-if="editable" :to="{name: 'booking'}"><el-button size="mini" icon="el-icon-edit" circle plain></el-button></router-link>
        <span v-if="order.scenario">{{order.scenario.name}}</span>
      </template>
      <table>
        <tbody>
          <tr v-if="order.time"><th>When</th><td>{{when}}</td></tr>
          <tr v-if="order.games"><th>Games</th><td>{{order.games}}</td></tr>
          <tr v-if="order.duration"><th>Duration</th><td>{{order.duration}} minutes</td></tr>
          <tr v-if="order.adults > 0">
            <th v-if="settings.default_players_type == 'adults_and_juniors'">Adults</th>
            <th v-if="settings.default_players_type == 'combined'">Players</th>
            <td>{{order.adults}}</td>
          </tr>
          <tr v-if="settings.default_players_type == 'adults_and_juniors' && order.juniors > 0"><th>Juniors</th><td>{{order.juniors}}</td></tr>
          <tr v-if="order.promo_code"><th>Promo code</th><td>{{order.promo_code}}</td></tr>
          <tr v-if="editable && timeLeft != null">
            <th>Order Expires In</th>
            <td>
              <countdown :time="timeLeft" v-if="timeLeft > 0">
                <template slot-scope="props">{{ props.minutes }} minutes, {{ props.seconds }} seconds.</template>
              </countdown>
              <div v-if="timeLeft <= 0">Expired</div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>Sub Total</th>
            <td>
              <i18n-n :value="bowlingAmount" format="currency"></i18n-n>
            </td>
          </tr>
        </tfoot>
      </table>
    </el-collapse-item>
    <el-collapse-item name="extras">
      <template slot="title">
        <router-link v-if="editable" :to="{name: 'extras'}"><el-button size="mini" icon="el-icon-edit" circle plain></el-button></router-link>
        <el-badge :value="selectedAddonsTotalQty" type="warning">
          Extras
        </el-badge>
      </template>
      <table>
        <tbody>
          <tr v-if="editable" v-for="addon in selectedAddons">
            <th>{{addon.qty}} x</th><td>{{addon.addon.conqueror_pro_price_key_name}}</td><td><el-button type="danger" size="small" icon="el-icon-delete" @click.prevent="removeAddon(addon.addon)" circle></el-button></td>
          </tr>
          <tr v-if="!editable" v-for="addon in order.selected_add_ons">
            <th>{{addon.qty}} x</th><td>{{addon.addon.conqueror_pro_price_key_name}}</td><td></td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>Sub Total</th>
            <td v-if="editable">
              <i18n-n :value="selectedAddonsTotal" format="currency"></i18n-n>
            </td>
            <td v-if="!editable">
              <i18n-n :value="+order.add_ons_amount" format="currency"></i18n-n>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </el-collapse-item>
      <table>
        <caption><i class="icon el-icon-info" /> Summary</caption>
        <tfoot>
          <tr>
            <th>Total</th>
            <td v-if="editable">
              <i18n-n :value="calculatedTotal" format="currency"></i18n-n>
            </td>
            <td v-if="!editable">
              <i18n-n :value="+booking.booking.total_value" format="currency"></i18n-n>
            </td>
          </tr>
        </tfoot>
      </table>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import dateMixin from '../mixins/dateMixin'
  import mobileMixin from '../mixins/mobileMixin'
  import VueCountdown from '@chenfengyuan/vue-countdown'

  export default {
    mixins: [dateMixin, mobileMixin],
    props: {
      editable: {
        type: Boolean,
        default: true
      },
      activeMobileSections: {
        type: Array,
        default: () => []
      }
    },
    components: {
      'countdown': VueCountdown
    },
    methods: {
      removeAddon(addon) {
        this.$store.commit('booking/removeSelectedAddon', addon.id)
      },
      redirectExpired() {
        if (this.order.status != 'initial' && this.timeLeft !== null && this.timeLeft <= 0) {
          this.$router.push({name: 'booking'})
        }
      }
    },
    watch: {
      timeLeft() {
        this.redirectExpired()
      }
    },
    computed: {
      ...mapState({
        settings: state => state.settings.tenant,
        booking: state => state.booking,
        user: state => state.session.user,
        order: state => state.order.order,
        settings: state => state.settings.tenant
      }),
      bowlingAmount() {
        if (this.settings.default_players_type == 'adults_and_juniors')
          return +this.order.bowling_amount

        let amount = 0
        for (let id in this.booking.options.priceKeys) {
          const qty = this.booking.options.priceKeys[id]
          const pk = this.order.scenario.all_price_keys.find((k) => k.id == id)
          if (pk) {
            // Price key qty should always be 1 for timed games no matter how many players
            /*
            const pkQty = 0
            const m = pk.tag.match(/PLAYERS=([\d\-]+)/)
            if (m) {
              if (m[1].indexOf('-') > -1) {
                const [minPlayersPerPk, maxPlayersPerPk] = m[1].split('-').map((x) => parseInt(x))
              } else {
                const playersPerPk = parseInt(m[1])
                

              }
            }
            */
            //const pkQty = pk.multiplier_type == "timed" ? 1 : qty
            //const pkQty = qty
            amount += pk.value * qty
          }
        }
        return amount
      },
      timeLeft() {
        if (this.order && this.order.booking_expires_at)
          return this.parseDate(this.order.booking_expires_at).getTime() - new Date().getTime()
        return null
      },
      ...mapGetters('booking', ['selectedAddons', 'selectedAddonsTotal']),
      customerAddress() {
        return [this.user.street_number, this.user.street, this.user.city, this.user.postcode].filter(function(e){return e}).join(', ')
      },
      customerName() {
        return [this.user.title, this.user.first_name, this.user.last_name].filter(function(e){return e}).join(' ')
      },
      when() {
        return this.dateTimeForDisplay(this.parseDate(this.order.time), "Europe/London")
      },
      calculatedTotal() {
        return parseFloat(this.bowlingAmount) + this.selectedAddonsTotal
      },
      selectedAddonsTotalQty() {
        if (!this.selectedAddons || !this.selectedAddons.length)
          return 0
        return 'x ' + this.selectedAddons.map((x) => x.qty).reduce((x, y) => x + y)
      }
    },
    created() {
      this.activeSections = this.activeMobileSections

      this.redirectExpired()
    },
    data() {
      return {
        activeSections: []
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/settings.scss";

  a {
    cursor: pointer;
    color: blue;
  }

  button.is-plain:hover, .router-link-exact-active button.is-plain {
    border-color: #f7a8a9;
    color: #f7a8a9;
  }

  table th {
    width: 8em;
  }

</style>
